import axios from "axios";

export const FooterAPI={
    get:function() {
       return axios({
            method:'GET',
            url: `${process.env.REACT_APP_API_URL}/get-setting`,
        })
    }
}
